import axios from 'axios';
import { url } from '../../../env';

// Reusa el patron HTTP del admin: axios directo + Bearer token leido en cada llamada.
const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  Accept: 'application/json',
});

const jsonHeaders = () => ({
  ...authHeaders(),
  'Content-Type': 'application/json',
});

export const vencimientosApi = {
  // GET /seguros-dashboard/vencimientos?tipo=&estado=&mes=&search=&aseguradora=&solo_proximos=&per_page=&page=
  // signal opcional (AbortController) para cancelar una busqueda en vuelo cuando llega otra.
  getVencimientos: (params = {}, signal) =>
    axios.get(`${url}/seguros-dashboard/vencimientos`, {
      headers: authHeaders(),
      params,
      signal,
    }),

  // GET /seguros-dashboard/cliente/{userId}
  getCliente: (userId) =>
    axios.get(`${url}/seguros-dashboard/cliente/${userId}`, {
      headers: authHeaders(),
    }),

  // POST /seguros-dashboard/pagos/{paymentId}  body { paid: bool }
  marcarPago: (paymentId, paid) =>
    axios.post(
      `${url}/seguros-dashboard/pagos/${paymentId}`,
      { paid },
      { headers: jsonHeaders() }
    ),

  // POST /seguros-dashboard/placas/{plateId}/renovacion  body { renovada: bool }
  renovarPlaca: (plateId, renovada) =>
    axios.post(
      `${url}/seguros-dashboard/placas/${plateId}/renovacion`,
      { renovada },
      { headers: jsonHeaders() }
    ),

  // POST /seguros-dashboard/obligacion/{id}  body { paid: bool }  -> tenencia/renta
  marcarObligacion: (id, paid) =>
    axios.post(
      `${url}/seguros-dashboard/obligacion/${id}`,
      { paid },
      { headers: jsonHeaders() }
    ),

  // POST /seguros-dashboard/insurance/{insuranceId}/completar-primas  body { years, amount? }
  completarPrimas: (insuranceId, years, amount) =>
    axios.post(
      `${url}/seguros-dashboard/insurance/${insuranceId}/completar-primas`,
      amount != null ? { years, amount } : { years },
      { headers: jsonHeaders() }
    ),

  // POST /seguros-dashboard/pagos/{paymentId}/editar  body { due_date?, amount? }
  editarPrima: (paymentId, { due_date, amount }) =>
    axios.post(
      `${url}/seguros-dashboard/pagos/${paymentId}/editar`,
      { due_date, amount },
      { headers: jsonHeaders() }
    ),

  // GET /seguros-dashboard/clientes/buscar?q=  -> autocomplete del wizard
  buscarClientes: (q) =>
    axios.get(`${url}/seguros-dashboard/clientes/buscar`, {
      headers: authHeaders(),
      params: { q },
    }),

  // POST /seguros-dashboard/cliente  -> alta manual (Flujo C)
  crearClienteExterno: (payload) =>
    axios.post(`${url}/seguros-dashboard/cliente`, payload, { headers: jsonHeaders() }),
};

export default vencimientosApi;
